module.exports = __webpack_public_path__ + "static/media/tom-1.d6bb6a85.mp3";